var React = require('react');
var ReactDOM = require('react-dom');
var Shopify = require('./shopify');
var ScrollToTop = require('./scroll-to-top');
var Utils = require('./utils');

module.exports = React.createClass({

  mixins: [ ScrollToTop ],

  getInitialState: function() {
    return { pp_content: "" }
  },

  componentDidMount: function() {

    document.title = "Privacy Policy - Ingledew's Shoes";

    this.scrollToTop('privacy-policy');
    Shopify.getSpecialPost('privacy-policy', this.postGot); 
  },

  postGot: function(post) {
    var content = Utils.reconstructPost(post.content);
    
    jQuery(ReactDOM.findDOMNode(this.refs.ppContent)).append(content.getAll());
  },

  rawMarkup: function() {
    return { __html: this.state.pp_content };
  },

  render: function() {
    return <main id="content" className="container" role="main">
            <div className="row">
                <div className="col-md-8 col-md-offset-2">
                    <p className="lead">{CMS.privacy_policy.prefix}</p>
                    <h1>{CMS.privacy_policy.title}</h1>
                    <div className="pp-wrap" ref="ppContent">
                    </div>
                </div>
            </div>
           </main>
  }
})